import { getFormattedAmount } from '@zonofi/common';

interface LedgerRowProps {
  date: string;
  paymentId: string;
  status: string;
  debit: number | undefined;
  credit: number | undefined;
}

export const LedgerRowContent: React.FC<LedgerRowProps> = ({
  date,
  paymentId,
  status,
  debit,
  credit,
}) => (
  <div className="ledger-grid ledger-view-content-row">
    <div className="ledger-view-content-row-ledger">
      <span className="ledger-view-content-row-ledger-date">{date}</span>
      <div className="ledger-view-content-row-ledger-info font-regular font-primary-regular">
        {paymentId && (
          <span className="ledger-view-content-row-ledger-info-text">
            {paymentId} •{' '}
            <span className="ledger-view-content-row-ledger-info-text">
              {status}
            </span>
          </span>
        )}
      </div>
    </div>
    <span className="ledger-view-content-row-text debit">
      {debit ? getFormattedAmount(Math.abs(debit), true) : '-'}
    </span>
    <span className="ledger-view-content-row-text credit">
      {credit ? getFormattedAmount(Math.abs(credit), true) : '-'}
    </span>
  </div>
);
